<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerText]="T.EVENT_SEND_MAIL_DIALOG_TITLE | translate"
	[headerIcon]="{fontSet: 'fad', fontIcon: 'fa-paper-plane'}"
	[matDialogData]="data"
	[rect]="rect"
	class="normalDuotoneHeaderIcon"
>
	<ng-container dialogContent>
		<form [formGroup]="sendMailForm" class="sendMailForm">
			<div>
				{{ T.EVENT_SEND_MAIL_DIALOG_HINT | translate }}
			</div>
			<mat-form-field class="full-width-form" color="accent">
				<mat-label>{{ T.EVENT_SEND_MAIL_DIALOG_SUBJECT | translate }}</mat-label>
				<input formControlName="subject" matInput />
				@if (sendMailForm.get("subject").hasError("required")) {
					<mat-error>
						{{ T.EVENT_SEND_MAIL_DIALOG_ERROR_SUBJECT | translate }}
					</mat-error>
				}
			</mat-form-field>

			<mat-form-field class="full-width-form" color="accent">
				<mat-label>{{ T.EVENT_SEND_MAIL_DIALOG_MESSAGE | translate }}</mat-label>
				<textarea
					[cdkAutosizeMaxRows]="15"
					[cdkAutosizeMinRows]="5"
					[class.editMode]="true"
					[readonly]="false"
					cdkTextareaAutosize
					formControlName="message"
					matInput
				></textarea>
			</mat-form-field>
		</form>
	</ng-container>

	<ng-container actions>
		<button (click)="close()" color="warn" mat-raised-button style="margin-right: 15px">
			{{ T.EVENT_SEND_MAIL_DIALOG_CLOSE | translate }}
		</button>

		<button (click)="ok()" [disabled]="sendMailForm.invalid" color="accent" mat-raised-button>
			{{ T.EVENT_SEND_MAIL_DIALOG_SEND | translate }}
		</button>
	</ng-container>
</sim-basic-material-dialog>
